import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_PACKAGE_REQUEST,
  ADD_PACKAGE_SUCCESS,
  ADD_PACKAGE_FAILURE,
  UPDATE_PACKAGE_REQUEST,
  UPDATE_PACKAGE_SUCCESS,
  UPDATE_PACKAGE_FAILURE,
  DELETE_PACKAGE_REQUEST,
  DELETE_PACKAGE_SUCCESS,
  DELETE_PACKAGE_FAILURE,
  GET_PACKAGE_REQUEST,
  GET_PACKAGE_SUCCESS,
  GET_PACKAGE_FAILURE,
} from "../constants/packageConstant";

export const addPackageAction = (packageData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_PACKAGE_REQUEST });
    console.log(packageData);

    const url = ApiUrl.addPackage;
    const { data } = await axios.post(url, packageData);

    if (data.success) {
      dispatch({
        type: ADD_PACKAGE_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_PACKAGE_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_PACKAGE_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const updatePackageAction =
  (packageId, packageDetails) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_PACKAGE_REQUEST });
      const URL = `${ApiUrl.updatePackage}?packageId=${packageId}`;
      const { data } = await axios.put(URL, packageDetails);
      if (data.success) {
        dispatch({
          type: UPDATE_PACKAGE_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_PACKAGE_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_PACKAGE_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deletePackageAction = (packageId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PACKAGE_REQUEST });
    const URL = `${ApiUrl.deletePackage}?packageId=${packageId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_PACKAGE_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_PACKAGE_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getPackageActionFn = (packageId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PACKAGE_REQUEST });
    const URL = `${ApiUrl.getPackageById}?packageId=${packageId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_PACKAGE_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_PACKAGE_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_PACKAGE_FAILURE,
        payload: error.response.data,
      });
    }
  }
};
